import { combineReducers } from "redux";
import customizer from "./customizer";
import auth from "./auth";
import alert from "./alert";
import drawer from "./drawer";
import renderList from "./renderList";
import workOrder from "./workOrder";
import assetAcceptance from "./assetAcceptance"

const rootReducer = combineReducers({
  customizer,
  auth,
  alert,
  drawer,
  renderList,
  workOrder,
  assetAcceptance
});

export default rootReducer;
